export default "__VITE_ASSET__C2Stg6ax__"